import { render, staticRenderFns } from "./deliverDraw.vue?vue&type=template&id=98b2b064&scoped=true&"
import script from "./deliverDraw.vue?vue&type=script&lang=js&"
export * from "./deliverDraw.vue?vue&type=script&lang=js&"
import style0 from "./deliverDraw.vue?vue&type=style&index=0&id=98b2b064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b2b064",
  null
  
)

export default component.exports